import { render, staticRenderFns } from "./NationalTrademarkForm.vue?vue&type=template&id=12d82e0c&"
import script from "./NationalTrademarkForm.vue?vue&type=script&lang=js&"
export * from "./NationalTrademarkForm.vue?vue&type=script&lang=js&"
import style0 from "./NationalTrademarkForm.vue?vue&type=style&index=0&id=12d82e0c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports